/* Wave stack builder.
   State is a list of {p: productId, v: variantId} — a variant id, never a
   loose option string, so anything in the stack is guaranteed orderable.
   The design draws five metals (18K, platinum); the real products carry
   three. Swatches are read off each product's own options instead of a
   fixed list, so the builder can only offer what actually exists. */
(function () {
  var METAL_HEX = {
    'yellow': '#e6c169', '18k yellow': '#d8a94a', 'white': '#dcdde1',
    'rose': '#e5b6a6', 'platinum': '#c9ccd2', 'silver': '#c9ccd2'
  };
  var METAL_RE = /gold|metal|colou?r/i;

  function money(cents, fmt) {
    var n = (cents / 100);
    var s = n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, s);
  }
  function esc(v) { return String(v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  // The stacking shot when there is one, otherwise the catalogue photo.
  function bandImage(v, p) { return (v && v.stack) || (v && v.image) || (p && p.image) || ''; }
  function isPrepared(v) { return !!(v && v.stack); }
  function swatchFor(value) {
    var v = String(value).toLowerCase();
    for (var k in METAL_HEX) if (v.indexOf(k) > -1) return METAL_HEX[k];
    return '#ded9e2';
  }

  function init(root) {
    var dataEl = document.getElementById(root.dataset.dataId);
    if (!dataEl) return;
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var products = DATA.products || [];
    var byId = {};
    products.forEach(function (p) { byId[p.id] = p; });

    var MAX = parseInt(root.dataset.max, 10) || 5;
    var KEY = 'nsh-wave:' + (root.dataset.collection || 'wave');
    var stack = [];
    try { stack = JSON.parse(sessionStorage.getItem(KEY)) || []; } catch (e) { stack = []; }
    // Drop anything that no longer exists — products change, saved stacks don't.
    stack = stack.filter(function (r) {
      var p = byId[r.p];
      return p && p.variants.some(function (v) { return v.id === r.v; });
    }).slice(0, MAX);

    var el = {
      empty: root.querySelector('[data-wave-empty]'),
      builder: root.querySelector('[data-wave-builder]'),
      layers: root.querySelector('[data-wave-layers]'),
      rows: root.querySelector('[data-wave-rows]'),
      subtotal: root.querySelector('[data-wave-subtotal]'),
      bag: root.querySelector('[data-wave-bag]'),
      hint: root.querySelector('[data-wave-hint]'),
      err: root.querySelector('[data-wave-err]'),
      grid: root.querySelector('[data-wave-grid]'),
      size: root.querySelector('[data-wave-size]'),
      mini: root.querySelector('[data-wave-mini]'),
      miniItems: root.querySelector('[data-wave-mini-items]'),
      miniTotal: root.querySelector('[data-wave-mini-total]')
    };

    var SIZE_KEY = KEY + ':size';
    function save() {
      try {
        sessionStorage.setItem(KEY, JSON.stringify(stack));
        if (el.size) sessionStorage.setItem(SIZE_KEY, el.size.value || '');
      } catch (e) {}
    }
    if (el.size) {
      try { el.size.value = sessionStorage.getItem(SIZE_KEY) || ''; } catch (e) {}
      el.size.addEventListener('change', function () { save(); el.err.textContent = ''; });
    }
    function variant(r) {
      var p = byId[r.p]; if (!p) return null;
      for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === r.v) return p.variants[i];
      return null;
    }
    function total() {
      return stack.reduce(function (a, r) { var v = variant(r); return a + (v ? v.price : 0); }, 0);
    }
    function metalIndex(p) {
      for (var i = 0; i < p.options.length; i++) if (METAL_RE.test(p.options[i].name)) return i;
      return -1;
    }
    // is there a real, purchasable variant if we change one option to val?
    function resolvable(p, cur, oi, val) {
      return p.variants.some(function (vv) {
        if (vv.options[oi] !== val || !vv.available) return false;
        return vv.options.every(function (o, k) { return k === oi || !cur || o === cur.options[k]; });
      });
    }
    // swap one option, keeping every other choice where possible
    function pickOption(rowIndex, oi, val) {
      var r = stack[rowIndex]; if (!r) return;
      var p = byId[r.p], cur = variant(r);
      var next = p.variants.filter(function (vv) {
        return vv.options[oi] === val && vv.options.every(function (o, k) { return k === oi || o === cur.options[k]; });
      })[0];
      if (!next) next = p.variants.filter(function (vv) { return vv.options[oi] === val && vv.available; })[0];
      if (next) { stack[rowIndex] = { p: r.p, v: next.id }; render(); }
    }

    function firstAvailable(p) {
      for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
      return p.variants[0];
    }

    function render() {
      var on = stack.length > 0;
      if (el.empty) el.empty.hidden = on;
      if (el.builder) el.builder.hidden = !on;
      root.classList.toggle('nsh-wave--active', on);

      // stacked band preview
      el.layers.innerHTML = '';
      stack.forEach(function (r, i) {
        var v = variant(r), p = byId[r.p];
        var img = document.createElement('img');
        img.className = 'nsh-wave__layer' + (isPrepared(v) ? ' nsh-wave__layer--flat' : '');
        // the band higher up the finger sits in front of the one below it
        img.style.zIndex = String(stack.length - i);
        img.src = bandImage(v, p);
        img.alt = p.title;
        img.loading = 'lazy';
        el.layers.appendChild(img);
      });

      // stack rows
      el.rows.innerHTML = '';
      stack.forEach(function (r, i) {
        var p = byId[r.p], v = variant(r);
        var mi = metalIndex(p);
        var row = document.createElement('div');
        row.className = 'nsh-wave__row';

        var move = '<div class="nsh-wave__move">' +
          '<button type="button" data-wave-move="-1" data-i="' + i + '" aria-label="Move up"' + (i === 0 ? ' disabled' : '') + '>&#9650;</button>' +
          '<button type="button" data-wave-move="1" data-i="' + i + '" aria-label="Move down"' + (i === stack.length - 1 ? ' disabled' : '') + '>&#9660;</button>' +
          '</div>';

        var thumb = '<img class="nsh-wave__thumb" src="' + bandImage(v, p) + '" alt="" loading="lazy">';

        var controls = '<div class="nsh-wave__opts">';
        // Metal first, whatever order the product lists its options in: the
        // swatches are the choice that changes how the stack looks, so they
        // should not sit behind a stone or a letter on some products and in
        // front on others.
        var order = p.options.map(function (o, i) { return i; }).sort(function (a, b) {
          var ma = METAL_RE.test(p.options[a].name) ? 0 : 1;
          var mb = METAL_RE.test(p.options[b].name) ? 0 : 1;
          return ma - mb || a - b;
        });
        order.forEach(function (oi) {
          var opt = p.options[oi];
          var cur = v ? v.options[oi] : '';
          var vals = opt.values;
          if (METAL_RE.test(opt.name)) {
            controls += '<div class="nsh-wave__swatches">';
            vals.forEach(function (val) {
              controls += '<button type="button" class="nsh-wave__swatch" data-wave-opt="' + i + ':' + oi +
                '" data-val="' + esc(val) + '" title="' + esc(val) + '" aria-pressed="' + (cur === val) + '"' +
                (resolvable(p, v, oi, val) ? '' : ' disabled') + ' style="background:' + swatchFor(val) + '"></button>';
            });
            controls += '</div>';
          } else if (vals.length <= 5) {
            controls += '<div class="nsh-wave__chips">';
            vals.forEach(function (val) {
              controls += '<button type="button" class="nsh-wave__chip" data-wave-opt="' + i + ':' + oi +
                '" data-val="' + esc(val) + '" aria-pressed="' + (cur === val) + '"' +
                (resolvable(p, v, oi, val) ? '' : ' disabled') + '>' + val + '</button>';
            });
            controls += '</div>';
          } else {
            // 26 letters or 12 stones would swamp the row as chips
            controls += '<label class="nsh-wave__sel"><span>' + opt.name + '</span><select data-wave-opt="' + i + ':' + oi + '">';
            vals.forEach(function (val) {
              controls += '<option value="' + esc(val) + '"' + (cur === val ? ' selected' : '') + '>' + val + '</option>';
            });
            controls += '</select></label>';
          }
        });
        if (p.textField) {
          controls += '<label class="nsh-wave__text"><span>' + p.textLabel + '</span>' +
            '<input type="text" data-wave-text="' + i + '" maxlength="' + (p.textMax || 9) +
            '" value="' + esc(r.t || '') + '" placeholder="' + esc(p.textLabel) + '"></label>';
        }
        controls += '</div>';

        var info = '<div class="nsh-wave__cell">' +
          '<a class="nsh-wave__name" href="' + p.url + '" target="_blank" rel="noopener">' + p.title + '</a>' +
          '<div class="nsh-wave__meta">' + money(v ? v.price : 0, DATA.money_format) + '</div>' +
          controls + '</div>';

        var rm = '<button type="button" class="nsh-wave__remove" data-wave-remove="' + i + '" aria-label="Remove">&times;</button>';
        row.innerHTML = move + thumb + info + rm;
        el.rows.appendChild(row);
      });

      var t = total();
      el.subtotal.textContent = 'Subtotal (Qty ' + stack.length + '): ' + money(t, DATA.money_format);
      el.bag.textContent = (root.dataset.bagLabel || 'Add stack to bag') + ' · ' + money(t, DATA.money_format);
      el.hint.textContent = stack.length >= MAX
        ? (root.dataset.hintMax || ('Five bands is the most we can size as one stack.'))
        : (root.dataset.hint || 'Want to add another? Select a band below.');

      // condensed bar mirrors the stack in miniature
      if (el.miniItems) {
        el.miniItems.innerHTML = '';
        stack.forEach(function (r, i) {
          var v = variant(r), p = byId[r.p];
          var item = document.createElement('div');
          item.className = 'nsh-wave__mini-item';
          item.innerHTML = '<span class="nsh-wave__mini-n">' + (i + 1) + '.</span>' +
            '<img class="nsh-wave__mini-img' + (isPrepared(v) ? ' nsh-wave__mini-img--flat' : '') +
            '" src="' + bandImage(v, p) + '" alt="" loading="lazy">';
          el.miniItems.appendChild(item);
        });
        el.miniTotal.textContent = money(t, DATA.money_format);
      }
      syncMini();

      // grid selection state
      Array.prototype.forEach.call(el.grid.querySelectorAll('[data-wave-card]'), function (c) {
        var id = parseInt(c.dataset.waveCard, 10);
        c.setAttribute('aria-pressed', stack.some(function (r) { return r.p === id; }) ? 'true' : 'false');
      });
      save();
    }

    // The bar only makes sense once there is a stack and the builder is off screen.
    var builderPastTop = false;
    function syncMini() {
      if (!el.mini) return;
      el.mini.hidden = !(stack.length > 0 && builderPastTop);
    }
    if (el.mini && el.builder && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        builderPastTop = entries[0].boundingClientRect.bottom <= 0;
        syncMini();
      }, { threshold: 0 }).observe(el.builder);
    }

    function toggle(id) {
      var p = byId[id]; if (!p) return;
      var at = stack.findIndex(function (r) { return r.p === id; });
      if (at > -1) { stack.splice(at, 1); render(); return; }
      if (stack.length >= MAX) { flash(root.dataset.hintMax || 'That is the most we can size as one stack.'); return; }
      var v = firstAvailable(p);
      if (!v) return;
      stack.push({ p: id, v: v.id });
      render();
    }

    function flash(msg) {
      el.err.textContent = msg;
      clearTimeout(flash._t);
      flash._t = setTimeout(function () { el.err.textContent = ''; }, 4000);
    }

    // A link to #wave anywhere on the page - the "Customize" card in the
    // row below, say - brings the builder into view, or the rings to pick
    // from while the stack is still empty.
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="#wave"], a[href$="#wave"]');
      if (!a) return;
      e.preventDefault();
      var target = el.builder.hidden ? root : el.builder;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-wave-card],[data-wave-move],[data-wave-remove],[data-wave-opt],[data-wave-clear],[data-wave-first],[data-wave-set],[data-wave-bag],[data-wave-customize]');
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute('data-wave-card')) { e.preventDefault(); toggle(parseInt(t.dataset.waveCard, 10)); return; }

      if (t.hasAttribute('data-wave-move')) {
        var i = parseInt(t.dataset.i, 10), j = i + parseInt(t.dataset.waveMove, 10);
        if (j < 0 || j >= stack.length) return;
        var tmp = stack[i]; stack[i] = stack[j]; stack[j] = tmp; render(); return;
      }

      if (t.hasAttribute('data-wave-remove')) { stack.splice(parseInt(t.dataset.waveRemove, 10), 1); render(); return; }

      if (t.hasAttribute('data-wave-opt')) {
        var parts = t.dataset.waveOpt.split(':');
        pickOption(parseInt(parts[0], 10), parseInt(parts[1], 10), t.dataset.val);
        return;
      }

      if (t.hasAttribute('data-wave-clear')) { stack = []; render(); return; }

      if (t.hasAttribute('data-wave-first')) {
        var f = products[0]; if (f) { stack = [{ p: f.id, v: firstAvailable(f).id }]; render(); } return;
      }

      if (t.hasAttribute('data-wave-set')) {
        var ids = (root.dataset.starter || '').split(',').filter(Boolean).map(Number);
        var picks = ids.map(function (id) { return byId[id]; }).filter(Boolean);
        if (!picks.length) picks = products.slice(0, 3);
        stack = picks.slice(0, MAX).map(function (p) { return { p: p.id, v: firstAvailable(p).id }; });
        render(); return;
      }

      if (t.hasAttribute('data-wave-customize')) {
        el.builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      if (t.hasAttribute('data-wave-bag')) { addToCart(t); return; }
    });

    root.addEventListener('input', function (e) {
      var box = e.target.closest('input[data-wave-text]');
      if (!box) return;
      var row = stack[parseInt(box.dataset.waveText, 10)];
      if (!row) return;
      row.t = box.value;
      save();
      if (el.err) el.err.textContent = '';
    });

    root.addEventListener('change', function (e) {
      var sel = e.target.closest('select[data-wave-opt]');
      if (!sel) return;
      var parts = sel.dataset.waveOpt.split(':');
      pickOption(parseInt(parts[0], 10), parseInt(parts[1], 10), sel.value);
    });

    function addToCart(btn) {
      if (!stack.length) return;
      btn.disabled = true;
      var size = el.size ? el.size.value : '';
      if (el.size && root.dataset.requireSize === 'true' && !size) {
        flash(root.dataset.sizeError || 'Choose a ring size first.');
        el.size.focus();
        btn.disabled = false;
        return;
      }
      var missing = null;
      stack.forEach(function (r) {
        var p = byId[r.p];
        if (p && p.textField && !(r.t || '').trim()) missing = missing || p;
      });
      if (missing) {
        flash((root.dataset.textError || 'Add the name for your ring.') + ' (' + missing.title + ')');
        var box = root.querySelector('input[data-wave-text]');
        if (box) box.focus();
        btn.disabled = false;
        return;
      }
      var body = {
        items: stack.map(function (r) {
          var item = { id: r.v, quantity: 1 };
          // property names match the personalizer's own fields so the order reads
          // identically whichever route the customer took
          var props = {};
          if (size) props[root.dataset.sizeProperty || 'Ring Size'] = size;
          if (root.dataset.karat) props[root.dataset.karatProperty || 'Gold Karat'] = root.dataset.karat;
          var bp = byId[r.p];
          if (bp && bp.textField && (r.t || '').trim()) props[bp.textField] = r.t.trim();
          for (var k in props) { item.properties = props; break; }
          return item;
        }),
        sections: 'cart-icon-bubble,cart-drawer'
      };
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
        .then(function (out) {
          if (!out.ok) { flash(out.j.description || out.j.message || 'Could not add this stack.'); return; }
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && out.j.sections && out.j.sections['cart-icon-bubble']) {
            var d = document.createElement('div');
            d.innerHTML = out.j.sections['cart-icon-bubble'];
            var fresh = d.querySelector('#cart-icon-bubble');
            if (fresh) bubble.innerHTML = fresh.innerHTML;
          }
          // the drawer must be re-rendered from the response, or it opens
          // showing whatever the cart held when the page first loaded
          var drawer = document.querySelector('cart-drawer');
          if (drawer && out.j.sections && out.j.sections['cart-drawer']) {
            var dd = document.createElement('div');
            dd.innerHTML = out.j.sections['cart-drawer'];
            var fresh = dd.querySelector('cart-drawer');
            if (fresh) drawer.innerHTML = fresh.innerHTML;
            drawer.classList.remove('is-empty');
          }
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        })
        .catch(function () { flash('Could not add this stack. Please try again.'); })
        .finally(function () { btn.disabled = false; });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-wave-root]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
